module.exports = __webpack_public_path__ + "static/img/succ.e708032.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/crm/succ.png
// module id = w/Xw
// module chunks = 2